import * as React from "react";
import type { SVGProps } from "react";
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M21.553 4q-.136-.015-.273 0H2.613q-.18.003-.353.053l9.633 9.594z"
    />
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="m22.54 4.927-9.707 9.666a1.333 1.333 0 0 1-1.88 0L1.333 5q-.045.163-.046.333v13.334A1.333 1.333 0 0 0 2.62 20h18.667a1.333 1.333 0 0 0 1.333-1.333V5.333a1.3 1.3 0 0 0-.08-.406M3.533 18.667h-.926v-.954l4.846-4.806.94.94zm17.74 0h-.933l-4.86-4.82.94-.94 4.847 4.806z"
    />
  </svg>
);
export default SvgMail;
